import SectionHeading from './SectionHeading'

export default SectionHeading
